import { redirect, type RouteObject } from 'react-router'

import { AlarmsScreen } from '../screens/alarms/AlarmsScreen.tsx'
import { TABLET_HOME_PATH } from '../shell/tabletNav.ts'

import { DEMO_ACCESS } from './demoAccess.ts'
import {
  TabletBatchDetailRoute,
  TabletBatchesRoute,
  TabletMonitoringRoute,
} from './tabletViews.tsx'

/**
 * 태블릿 kiosk 라우트 조각 — `apps/console/src/routes.tsx` 의 `/tablet` 아래에 그대로 펼친다.
 *
 * 🔴 **화면을 새로 만들지 않았다.** 콘솔 화면 3종을 그대로 싣고 이동 규칙만 태블릿 것으로 준다.
 *    이동을 끼우는 어댑터는 `tabletViews.tsx` 에 있다.
 *
 * 무엇을 싣고 왜 그것인지는 `shell/tabletNav.ts` 가 쥔다 — 목록을 고치면 내비도 라우트도 따라온다.
 */
export const tabletRoutes: RouteObject[] = [
  { index: true, loader: () => redirect(TABLET_HOME_PATH) },

  { path: 'monitoring', element: <TabletMonitoringRoute /> },
  { path: 'monitoring/:moduleKey', element: <TabletMonitoringRoute /> },

  { path: 'batches', element: <TabletBatchesRoute /> },
  { path: 'batches/:batchId', element: <TabletBatchDetailRoute /> },

  { path: 'alarms', element: <AlarmsScreen access={DEMO_ACCESS} /> },
]
